<template>
  <p class="clearfix mb-0">

    <span class="float-md-right d-none d-md-block">By Up.law with 
      <feather-icon
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current"
      />
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
